import React from 'react';
import RadioGroupMui, { RadioGroupProps } from '@material-ui/core/RadioGroup';

export const RadioGroup: React.FC<RadioGroupProps> = ({ children, ...rest }) => {
	return <RadioGroupMui {...rest}>{children}</RadioGroupMui>;
};
